












































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({
  watch: {
    visible: {
      handler(val) {
        console.log('---显示选择语速', val);
        this.show = val;
      },
      immediate: true,
    },
  },
})
export default class ChooseSpeed extends Vue {
  @Prop() selectedSpeed: string;
  @Prop({ default: true }) isShowTitle: boolean;
  @Prop() visible: boolean;
  speedList = ['0.9', '1.0', '1.1', '1.2', '1.3', '1.4', '1.5', '1.6', '1.7', '1.8', '1.9', '2.0'];
  show = false;
  chooseSpeed(speed) {
    this.$emit('onPickSpeed', speed);
  }
  closePopup() {
    this.$emit('close');
  }
  /**
   * 确定
   */
  confirmChoose() {
    console.log('---确认选择');
    this.$emit('confirm');
  }
  submitRate() {
    //触发对应的函数
    console.log('---popup提交选择'); //todo
    this.$emit('close');
  }
}
